import GrowthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';

const getShouldShowModularOnboarding = () => {
  return GrowthAcquisitionExperiments.preview('showModularOnboarding');
};

const getShouldUseMLInferredRole = () => {
  return GrowthAcquisitionExperiments.preview('useMLInferredRole');
};

export { getShouldShowModularOnboarding, getShouldUseMLInferredRole };
